import * as React from "react";

import type { MediaDockShellProps } from "@/components/OmniCine/Docks/shared/mediaDock.types";

function cx(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(" ");
}

export default function MediaDockShell({
  className = "",
  mode,
  title,
  subtitle,
  kindChip,
  sourceChip,
  isPinned,
  onTogglePin,
  onClose,
  bodyHeight,
  body,
  controls,
}: MediaDockShellProps): JSX.Element {
  return (
    <div
      className={cx(
        "rounded-2xl border border-white/12 text-white overflow-hidden",
        mode === "overlay"
          ? "bg-[linear-gradient(165deg,rgba(8,18,28,0.92)_0%,rgba(10,15,24,0.9)_46%,rgba(16,8,28,0.88)_100%)] backdrop-blur-xl shadow-[0_24px_75px_rgba(0,0,0,0.55),0_0_0_1px_rgba(120,220,255,0.16),0_0_40px_rgba(72,162,255,0.18)]"
          : "bg-black/35 backdrop-blur-md shadow-[0_12px_40px_rgba(0,0,0,0.35)]",
        "transition-all duration-300",
        className,
      )}
      data-oc-media-panel-mode={mode}
      role="region"
      aria-label="Media Panel"
      style={{ width: 720, maxWidth: "92vw" }}
    >
      <div className="flex items-center gap-2 h-11 px-3 border-b border-white/10">
        <div className="min-w-0 flex-1">
          <div className="truncate font-semibold tracking-tight text-[14px]">{title}</div>
          <div className="truncate text-[10px] tracking-normal opacity-60 mt-0.5">{subtitle}</div>
        </div>

        <div className="flex-none text-[10px] px-2 py-0.5 rounded-md bg-white/8 border border-white/15 uppercase tracking-[0.12em] opacity-80">
          {kindChip}
        </div>

        {sourceChip && (
          <div className="hidden sm:flex flex-none text-[10px] px-2 py-0.5 rounded-md bg-cyan-300/8 border border-cyan-200/20 tracking-wide opacity-80">
            {sourceChip}
          </div>
        )}

        <button
          type="button"
          onClick={onTogglePin}
          className={cx(
            "h-7 px-2.5 rounded-lg text-[11px] font-semibold leading-none border transition-colors",
            isPinned
              ? "bg-cyan-300/22 border-cyan-300/55 text-cyan-50 hover:bg-cyan-300/28"
              : "bg-white/8 border-white/15 text-white/88 hover:bg-white/14",
          )}
          aria-pressed={isPinned}
        >
          {isPinned ? "Pinned" : "Pin"}
        </button>

        <button
          type="button"
          onClick={onClose}
          className="h-7 px-3 rounded-lg text-xs font-medium leading-none bg-white/10 border border-white/12 hover:bg-white/14"
        >
          Close
        </button>
      </div>

      <div className="px-2.5 pb-2.5 pt-2 flex flex-col gap-2" style={{ height: bodyHeight }}>
        {body}
        {controls}
      </div>
    </div>
  );
}